<template>
	<div style="background-color: #f6f6f6">
		<Header :isHome="false"></Header>
		<div class="container" style="padding-top: 7rem;padding-bottom: 3rem;">
			<div class="row">
				<div style="display:flex;flex-direction: column;width: 100%;">
					<div style="display: flex;align-items: center;justify-content: space-between;" class="searchmain-box">
						
						<div style="display: flex;flex-wrap: nowrap;width: 100%;overflow: scroll;" class="noscrollbar">
							<div style="cursor: pointer;" v-for="(item, selindex) in selectlist" :key="selindex">
								<div class="news-l-item" :class="{ 'news-l-item-active': type==selindex+1}" style="cursor: pointer;width: max-content;" @click="changetype(selindex+1)">{{item}}</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;background-color: #fff;border-radius: 0.2rem;" class="search-box-input">
							<input type="text" v-model="keyword" style="max-width: 100%;border: none;background-color: transparent;color: #000;font-size: 1rem;font-weight: bold;padding: 0.5rem 1rem;" @keydown.enter="getdata()">
							<img src="../../assets/imgs/search-dark.png" style="width: 1rem;height: 1rem;cursor: pointer;" @click="getdata()">
						</div>
					</div>
					
					
					<!-- 全局搜索 -->
					<div style="" class="search-main" v-if="type == 1">
						<div style="">
							<div class="title-box">
								<img src="../../assets/imgs/export-title-icon.png" class="title-icon">
								<span class="title-text">Search Results For <span style="color: #62e0c9;">{{keyword}}</span></span>
							</div>
							<div style="" class="title-dec">
								Displaying {{data.totalCount}} results
							</div>
						</div>
						
						<div v-if="(data.articles.length+data.circles.length+data.experts.length+data.providers.length)==0" style="margin-top: 5rem;display: flex;align-items: center;justify-content: center;
								flex-direction: column;">
							<img src="../../assets/imgs/notfound.svg"  style="width: 20rem;">
							<!-- <div style="font-size: 2.5rem;color: #999;width: 35rem;text-align: center;margin-top: 3rem;">Sorry, there were no search results even after a full search</div> -->
						</div>
						
						<!-- 新闻 -->
						<div style="" class="searchmain-s1" v-if="data.articles.length!=0&&!isMobile">
							<div class="r-title">
								<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
								<span style="z-index: 1;position: relative;">Information</span>
							</div>
							
							<div class="news-left-box hover-up transition-normal" style="cursor: pointer;" v-for="(item, atriclesindex) in data.articles" :key="atriclesindex" @click="tonewsdetail(item.id)">
								<div class="news-left-box-img" :style="{backgroundImage: 'url('+item.coverImage+')'}"></div>
								<div class="news-left-box-r" style="height:10rem">
									<div style="flex: 1;">
										<div class="news-left-box-r-title text-hover">{{item.title}}</div>
										<div class="news-left-box-r-dec">{{item.subTitle}}</div>
									</div>
									<div style="display: flex;align-items: center;margin-top: 0.5rem;">
										<span class="news-left-box-r-icontext">{{item.createdAt|format}}</span>
									</div>
								</div>
							</div>
							
							<div style="display: flex;align-items: center;justify-content: center;margin-top: 2rem;" v-show="data.articles.length>2">
								<div style="" class="morebtn" @click="changetype(2)">More</div>
							</div>
						</div>
						
						<div style="" class="searchmain-s1" v-if="data.articles.length!=0&&isMobile">
							
							<div class="r-title">
								<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
								<span style="z-index: 1;position: relative;">Information</span>
							</div>
							<ul class="list-post" style="margin-top: 1rem;">
							    <li class="mb-20 wow fadeInUp animated" :data-wow-delay="'0.'+atriclesindex*2" v-for="(item, atriclesindex) in data.articles" @click="tonewsdetail(item.id)">
							        <div class="d-flex bg-white has-border p-25 hover-up transition-normal border-radius-5" style="cursor: pointer;">
							            <div class="post-content media-body">
							                <h6 class="post-title mb-15 text-limit-2-row font-medium text-hover" style="font-size: 1rem;">{{item.title}}</h6>
							                <div class="entry-meta meta-1 float-left font-x-small text-uppercase">
							                    <!-- <span class="post-on">{{item.createdAt|format}}</span> -->
							                    <span class="post-by">{{item.browseCount}} views</span>
							                </div>
							            </div>
							            <div class="post-thumb post-thumb-80 d-flex ml-15 border-radius-5 img-hover-scale overflow-hidden" >
							                <span class="color-white">
							                    <!-- <img :src="hotData.items[0].coverImage" alt=""> -->
											<div  :style="{backgroundImage: 'url('+item.coverImage+')'}"  class="news-img-box"></div>
							                </span>
							            </div>
							        </div>
							    </li>
								<div style="display: flex;align-items: center;justify-content: center;margin-top: 2rem;" v-show="data.articles.length>2">
									<div style="" class="morebtn" @click="changetype(2)">More</div>
								</div>
							</ul>
						</div>
						
						<!-- 圈子 -->
						<div style="margin-top: 3rem;" v-if="data.circles&&data.circles.length!=0">
							
								<div class="r-title">
									<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
									<span style="z-index: 1;position: relative;">Topics</span>
								</div>
								<div style="border: 1px solid #eee;display: flex;flex-direction: column;padding: 2rem;border-radius: 1rem;margin-top: 2rem;cursor: pointer;"
										v-for="(item, circlesindex) in data.circles" :key="circlesindex"
										class="hover-up transition-normal" @click="tocircletopic(item.id)">
									<div style="display: flex;align-items: center;">
										<div style="flex: 1;display: flex;align-items: center;">
											<div class="avatar" :style="{backgroundImage:'url('+item.avatar+')'}" style="min-width: 4rem;height: 4rem;margin-right: 1rem;"></div>
											<div style="display: flex;flex-direction: column;">
												<div style="font-weight: bold;font-size: 1.2rem;">{{item.title}}</div>
												<div style="display: flex;flex-wrap: wrap;">
													<span v-for="(tag, tindex) in item.tags" :style="{color:colorlist[tindex]}" style="margin-right: 0.5rem;font-size: 0.5rem;">#{{tag.name}}</span>
												</div>
											</div>
										</div>
										<div style="display: flex;align-items: center;" v-if="!isMobile">
											<img src="../../assets/imgs/dis-right-icon.png" style="width: 1rem;height: 1rem;margin-right: 0.5rem;">
											<div style="margin-right: 2rem;">{{item.followCount}}</div>
											<div style="display: flex;">
												<div :style="{backgroundImage:'url('+avatar+')'}" v-for="(avatar, avatarindex) in item.avatars" :key="avatarindex"
														style="width: 2rem;height: 2rem;border-radius: 50%;margin-left: -0.5rem;background-position: center;background-repeat: no-repeat;background-size: cover;"></div>
											</div>
										</div>
									</div>
									<div style="font-size: 1rem;color: #333;margin: 1rem 0;">
										{{item.profile}}
									</div>
									
									<div style="display: flex;align-items: center;justify-content: flex-end;" v-if="isMobile">
										<img src="../../assets/imgs/dis-right-icon.png" style="width: 1rem;height: 1rem;margin-right: 0.5rem;">
										<div style="margin-right: 2rem;">{{item.followCount}}</div>
										<div style="display: flex;">
											<div :style="{backgroundImage:'url('+avatar+')'}" v-for="(avatar, avatarindex) in item.avatars" :key="avatarindex"
													style="width: 2rem;height: 2rem;border-radius: 50%;margin-left: -0.5rem;background-position: center;background-repeat: no-repeat;background-size: cover;"></div>
										</div>
									</div>
								</div>
								<div style="display: flex;align-items: center;justify-content: center;margin-top: 2rem;" v-show="data.circles.length>2">
									<div style="" class="morebtn" @click="changetype(3)">More</div>
								</div>
						</div>
						
						
						<div style="margin-top: 3rem;" v-if="data.experts&&data.experts.length!=0">
							
								<div class="r-title">
									<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
									<span style="z-index: 1;position: relative;">Experts</span>
								</div>
								<div style="display: flex;margin-top: 2rem;" v-for="(item, expertindex) in data.experts" :key="expertindex">
									<div :style="{backgroundImage:'url('+item.avatar+')'}"
											style="background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 0.5rem;height: 13rem;min-width: 10rem;margin-right: 1rem"></div>
									<div style="background-color: #fff;box-shadow: 0px 3px 2rempx -1rempx rgba(0,0,0,0.25);padding: 1rem;border: 1px solid #eee;border-radius: 0.2rem;">
										<div style="font-size: 1rem;font-weight: bold;">{{item.realName}}</div>
										<div style="margin-top: 1rem;" class="profile">{{item.profile}}</div>
									</div>
								</div>
								<div style="display: flex;align-items: center;justify-content: center;margin-top: 2rem;" v-show="data.experts.length>2">
									<div style="" class="morebtn" @click="changetype(4)">More</div>
								</div>
						</div>
						
						<div style="margin-top: 3rem;" v-if="data.providers&&data.providers.length!=0">
							
								<div class="r-title">
									<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
									<span style="z-index: 1;position: relative;">Service Providers</span>
								</div>
								<div class="hover-up transition-normal fadeIn animated supplier" style="border: 2px solid #eee;background-color: #fff;padding: 1rem;display: flex;margin: 1rem 0;border-radius: 1rem;"
										v-for="(item, supplierindex) in data.providers" :key="supplierindex">
									<div :style="{backgroundImage: 'url('+item.coverImage+')'}" @click="tosupplierdetail(item)" class="main-img" style="cursor: pointer;"></div>
									<div style="display: flex;flex-direction: column;">
										<div style="cursor: pointer;" class="main-title" @click="tosupplierdetail(item)">{{item.providerName}}</div>
										<div style="display: flex;flex-wrap: wrap;cursor: pointer;" @click="tosupplierdetail(item)">
											<div v-for="(c, index3) in item.certifications" :key="index3" style="padding:0rem 0.5rem;border: 1px solid #D8D8D8;border-radius: 2rem;font-size: 0.5rem;
											display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.5rem;">{{c.name}}</div>
										</div>
										<div style="font-size: 0.7rem;color: #666;cursor: pointer;" @click="tosupplierdetail(item)">{{item.providerDescription}}</div>
									</div>
								</div>
								<div style="display: flex;align-items: center;justify-content: center;margin-top: 2rem;" v-show="data.providers.length>2">
									<div style="" class="morebtn" @click="changetype(5)">More</div>
								</div>
						</div>
					</div>
				
					<Searchdetail :type="type" :keyword="ckeyword" v-else></Searchdetail>
					
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	
			import axios from 'axios'
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			import {baseUrl} from '../../assets/js/public.js'
			
			import Searchdetail from '/src/components/search/searchdetail.vue'
			export default {
				data() {
					return {
						//1全局 2新闻 3圈子 4专家 5供应商
						type:1,
						colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
						data:{
							articles:[],
							circles:[],
							experts:[],
							providers:[]
						},
						keyword:'',
						selectboxshow:false,
						ckeyword:'',
						isMobile: false,
						selectlist: ['All results', 'Information', 'Discussion', 'Consultant', 'Service Providers'],
						islogin:false,
						//   isuserlevel: false,
      //   默认全部都是会员
      isuserlevel: true,
					}
				},
				components: {
					Header,
					Footer,
					Searchdetail
				},
				methods: {
					getdata(){
						this.ckeyword = this.keyword
						this.request({
							method: 'get',
							url:'/gci/search?keyword='+this.keyword,
						}).then(res => {
							this.data = res.data
							this.$bus.$emit('loading', false)
						}).catch(error => {
							console.error(error.response)
						})
					},
					tonewsdetail(id){
						// 未登录
						if(!this.islogin){
							// 判断移动端
							if(this.isMobile){
								this.$router.push({name:'mlogin',query:{type:1}})
							}else{
								localStorage.setItem('logintype', 1)
								this.$bus.$emit("login", true);
							}
							// 判断是否是会员
						}else if(!this.isuserlevel){
							// this.$router.push('userlevel')
							this.$bus.$emit('userleveldialog', true)
						}else{
							this.$router.push({name:'newsdetail',query:{id:id}})
						}
					},
					tocircletopic(id){
						// 未登录
						if(!this.islogin){
							// 判断移动端
							if(this.isMobile){
								this.$router.push({name:'mlogin',query:{type:1}})
							}else{
								localStorage.setItem('logintype', 1)
								this.$bus.$emit("login", true);
							}
							// 判断是否是会员
						}else if(!this.isuserlevel){
							// this.$router.push('userlevel')
							this.$bus.$emit('userleveldialog', true)
						}else{
							this.$router.push({name:'circletopic',query:{id:id}})
						}
					},
					tosupplierdetail(item){
						// 未登录
						if(!this.islogin){
							// 判断移动端
							if(this.isMobile){
								this.$router.push({name:'mlogin',query:{type:1}})
							}else{
								localStorage.setItem('logintype', 1)
								this.$bus.$emit("login", true);
							}
							// 判断是否是会员
						}else if(!this.isuserlevel){
							// this.$router.push('userlevel')
							this.$bus.$emit('userleveldialog', true)
						}else{
							this.$router.push({name:'supplierdetail',query:{id:item.id}})
						}
					},
					changetype(type){
						this.type = type
					}
				},
				created() {
					this.$bus.$emit('loading', true)
				},
				mounted() {
					localStorage.getItem('isMobile') == 'null'?this.isMobile = false:this.isMobile = true
					if(localStorage.getItem('token')){
						this.islogin = true
						let userinfo = JSON.parse(localStorage.getItem('user'))
						if(userinfo.vip.id!=1){
							this.isuserlevel = true
						}
					}
					this.keyword = this.$route.query.keyword
					this.ckeyword = this.$route.query.keyword
					this.type = parseInt(this.$route.query.type)
					if(this.type == 1 ){
						this.getdata()
					}
				}
			}
</script>

<style scoped lang="scss">
	li{list-style:none}
	.morebtn{
		background: linear-gradient(270deg, #D2FDED 0%, #73F4F1 100%);border-radius: 5rem;display: flex;align-items: center;justify-content: center;
				padding: 0.5rem 1rem;width: 6rem;font-weight: bold;font-size: 1rem;cursor: pointer;
	}
	.morebtn:hover{
		background: #040404;color: #fff;
	}
	.title-text{
		margin-left:-2rem;
		font-size:1.5rem
	}
	.title-box{
		display:flex;align-items: center;justify-content: center;font-weight: 900;color: #000;font-size: 3rem;
	}
	.title-icon{
		width: 3rem;height: 3rem;margin-top: 1rem;
	}
	
		.r-title{
			height: 3rem;
			font-size: 1.5rem;
			font-weight: bold;
			position: relative;
			.r-title-bg{
				width: 13rem;position: absolute;left: -0.5rem;top: -2rem
			}
		}
		
	
	.news-left-box{
		background: #FFFFFF;
		// box-shadow: 0px 4px 2.5rem -2px rgba(0,0,0,0.08);
		border: 1px solid #E2E2E2;
		border-radius: 1rem;
		padding: 1rem;
		margin-bottom: 1rem;
		display: flex;
		align-items: center;
		margin-top:2rem;
		
		&-img{
			min-width: 10rem;height: 10rem;border-radius: 0.1rem;
			background-size: cover;background-repeat: no-repeat;background-position: center center;
		}
		&-r{
			display: flex;flex-direction: column;margin-left: 1rem;width: 100%;
			&-title{
				font-size: 1.2rem;
				font-weight: bold;
				color: #333;
			}
			&-dec{
				font-size: 0.7rem;
				font-weight: 400;
				color: #666;
				margin-top: 0.5rem;
			}
			&-tags{
				font-size: 0.5rem;
				margin-top: 0.5rem;
				display: flex;
			}
			&-icon{
				width: 1.5rem;height: 1.5rem;margin-right: 0.2rem;
			}
			&-icontext{
				font-size: 0.5rem;color: #666;margin-right: 1rem;
			}
			&-time{
				font-size: 0.5rem;
				color: #999;
				font-weight: 400;
			}
		}
	}
	
	
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 50%;
	}
	
	.profile{
			margin-top: 1rem;
			display: -webkit-box;
			-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
	}
	.main-img{
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		min-width: 10rem;
		height: 10rem;
		margin-right: 1rem;border-radius: 0.2rem;
	}
	.main-title{
		color: #000;font-size: 1.5rem;font-weight: bold;margin-bottom: 0.5rem;
	}
	
	.search-main{
		background-color: #fff;border-radius: 1rem;margin-top:2rem;padding:3rem
	}
	.title-dec{
		display: flex;align-items: center;justify-content: center;font-size: 1.2rem;margin-top: 0rem;color: #999;
	}
	.searchmain-s1{
		margin-top: 1rem;
	}
	
	
	.news-img-box{
		background-size:cover;
		background-repeat: no-repeat;
		background-position: top center ;
		width: 5.625rem;
	    height: 5rem;
		transition: transform .5s;
	}
	.news-img-box:hover{
		    -webkit-transform: scale(1.1);
		    -ms-transform: scale(1.1);
		    transform: scale(1.1);
		    -webkit-transition: -webkit-transform .5s;
		    transition: -webkit-transform .5s;
		    -o-transition: transform .5s;
		    transition: transform .5s;
		    transition: transform .5s,-webkit-transform .5s;
	}
	
	
	.news-l-item{
		background-color: #fff;
		color: #333;
		font-size: 0.9rem;
		font-weight: bold;
		// padding: 0.5rem;
		border-radius: 0.2rem;
		margin-right: 1rem;
		border: 1px solid #E0E0E0;;
		margin-top: 1rem;
		display: flex;align-items: center;justify-content: center;
		// width: 6rem;
		// height: 2rem;
		padding: 0.5rem 1rem;
	}
	.news-l-item-active{
		background-color: #31ffda;color: #333;
		border:1px solid transparent
	}
	
	.noscrollbar::-webkit-scrollbar{display: none;}
	.search-box-input{
		img{
			margin-right: 2rem;
		}
	}
	@media (max-width:767px) {
		.row{
			margin:0
		}
		.search-main{
			padding: 1rem;
		}
		.news-left-box-r-title{
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.news-left-box-r-dec{
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				overflow: hidden;
		}
		.title-box{
			.title-icon{
				display: none;
			}
			.title-text{
				margin-left: 0;
				line-height:1.2;
				text-align: center;
			}
		}
		.title-dec{
			justify-content: center;
		}
		.searchmain-box{
			flex-direction: column-reverse;
			align-items: flex-start !important;
		}
		.search-box-input{
			width:100%;
			height: 3rem;
			input{
				min-width: 20rem;
				font-size: 1.2rem !important;
			}
			img{
				margin-right: 1rem;
			}
		}
		.search-box-select{
			margin-top: 2rem;
		}
		.searchmain-box-select-content{
			padding-top:5rem !important
		}
		.search-main{
			margin-top: 1rem;
		}
		.searchmain-s1{
			margin-top: 2rem;
		}
		.news-left-box{
			margin-top:0rem
		}
		.r-title{
			font-size:1.2rem
		}
		.supplier{
			flex-direction: column;	
		}
		.main-title{
			font-size: 1.2rem;margin-top: 1rem;
		}
		.main-img{
			margin-right: 0;
		}
		.supplier{
			box-shadow:0 10px 10px rgba(0, 0, 0, 0.08)
		}
	}
</style>